import * as t from 'io-ts';

export enum userStatus {
  active = 'active',
  deactivated = 'deactivated',
  loginBlocked = 'login_blocked',
  withdrawn = 'withdrawn',
}

export enum userFlag {
  no_flag = 'no_flag',
  red_flag = 'red_flag',
  yellow_flag = 'yellow_flag',
}

export const participantStatusSchema = t.union([
  t.literal(userStatus.active),
  t.literal(userStatus.deactivated),
  t.literal(userStatus.loginBlocked),
  t.literal(userStatus.withdrawn),
], 'participantStatusSchema');
export type ParticipantStatusType = t.TypeOf<typeof participantStatusSchema>;

export const participantTransitionSchema = t.union([
  t.literal(userStatus.active),
  t.literal(userStatus.deactivated),
  t.literal(userStatus.loginBlocked),
  t.literal(userStatus.withdrawn),
], 'participantTransitionSchema');
export type ParticipantTransition = t.TypeOf<typeof participantTransitionSchema>;

export const participantNewStatusSchema = t.type({
  status: participantStatusSchema
}, 'participantNewStatusSchema');
export type ParticipantNewStatusType = t.TypeOf<typeof participantNewStatusSchema>;

export const participantFlagSchema = t.union([
  t.literal(userFlag.no_flag),
  t.literal(userFlag.red_flag),
  t.literal(userFlag.yellow_flag),
], 'participantFlagSchema');
export type ParticipantFlagType = t.TypeOf<typeof participantFlagSchema>;